export default __webpack_public_path__ + "static/media/community-headline-stickers.4021d70b.png";